import { gql } from 'graphql-request';

const PRODUCT_IMAGES = gql`
  query GetProductByHandle($handle: String!) {
    productByHandle(handle: $handle) {
      id
      title
      images(first: 1) {
        edges {
          node {
            url
            altText
          }
        }
      }
    }
  }
`;

export { PRODUCT_IMAGES };
